<template>
    <div class="MAM_terminalTransaction">
        <!-- 交易明细 -->
        <el-card class="box-card" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
            </div>
            <el-form :inline="true" :model="transctionForm" class="demo-form-inline">
                <el-form-item>
                    <el-date-picker
                            v-model="rangeDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="交易开始日期"
                            end-placeholder="交易结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="handleSearch(transctionForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <div style="margin-bottom: 10px;">
                <div class="tableTitle">
                    <span class="st-label">交易总额：</span>
                    <span class="st-word-aux">{{tableTitle.money_count}}</span>
                </div>
                <div class="tableTitle">
                    <span class="st-label">交易笔数：</span>
                    <span class="st-word-aux">{{tableTitle.count}}&nbsp;笔</span>
                </div>
            </div>
            <el-table
                    :data="transctionTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
            >
                <!-- id -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 订单号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="transaction_number"
                        label="订单号"
                        min-width="200"
                ></el-table-column>
                <!-- 终端类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="brand_name"
                        label="终端类型"
                        min-width="120"
                ></el-table-column>
                <!-- SN码 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="terminal_sn"
                        label="SN码"
                        min-width="120"
                ></el-table-column>
                <!-- 终端归属代理名称 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="real_name"
                        :label="level > 1 ? '终端所属团队名称' : '终端归属代理名称'"
                        min-width="120"
                ></el-table-column>
                <!-- 终端归属代理手机号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="phone"
                        :label="level > 1 ? '终端所属团队手机号' : '终端归属代理手机号'"
                        min-width="150"
                >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                            <p>{{ scope.row.phone | desMobile }}</p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 终端号 -->
                <!-- <el-table-column
                        header-align="center"
                        align="center"
                        prop="card_id"
                        label="交易卡号"
                        min-width="160"
                ></el-table-column> -->
                <!-- 商户号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="merchant_number"
                        label="商户号"
                        min-width="130"
                ></el-table-column>
                <!-- 交易类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="pay_type"
                        label="交易类型"
                        min-width="80"
                ></el-table-column>
                <!-- 卡类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="card_type"
                        label="卡类型"
                        min-width="60"
                        :formatter="formatCard"
                ></el-table-column>
                <!-- 结算周期 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="settle_type"
                        label="结算周期"
                        min-width="120"
                        :formatter="formatSettle"
                ></el-table-column>
                <!-- 交易时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="transaction_time"
                        label="交易时间"
                        min-width="150"
                ></el-table-column>
                <!-- 交易金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="transaction_money"
                        label="交易金额"
                        min-width="120"
                ></el-table-column>
                <!-- 终端交易费率 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="terminal_rate"
                        label="终端交易费率"
                        min-width="120"
                ></el-table-column>
                <!-- 单笔秒到手续费 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="sec_fee"
                        label="单笔手续费"
                        min-width="120"
                ></el-table-column>
                <!-- 交易分润 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="income"
                        label="交易分润"
                        min-width="120"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleInfo(scope.row)" type="text" size="small" v-if="level == 0 || level == 1">查看</el-button>
                        <!-- <el-button @click="handleInfos(scope.row)" type="text" size="small">查询出款状态</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                    :currentPage="page.currentPage"
                    :pageSize="page.pageSize"
                    :total="page.total"
                    @watchCurrent="getCurrent"
                    @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
        <transaction-info
                v-if="infoIsShow"
                :infoIsShow="infoIsShow"
                :detail="detail"
                @infoClose="infoClose"
        ></transaction-info>
        <transaction-status
                v-if="statusIsShow"
                :statusIsShow="statusIsShow"
                :detail="detail"
                @infoClose="infoClose"
        ></transaction-status>
    </div>
</template>

<script>
    import paginations from '../../../components/pagination/paginations';
   
    import transactionInfo from '../../dataManagement/transactionDetail/DM_transctionInfo';
    import transactionStatus from '../../dataManagement/transactionDetail/DM_transactionStatus';
    export default {
        name: "MAM_terminalTransaction",
        data() {
            return {
                tableTitle: {
                    count: 0,
                    money_count: 0
                },
                currentDate: '',
                pickerOptions: {},
                infoIsShow: false, //弹窗
                statusIsShow: false, //弹窗
                detail: {}, //当前行
                brandList: [], //终端类型列表
                payTypeList: [], //支付类型
                rangeDate: [], //时间范围
                transctionForm: {
                    sn: this.$route.query.sn,  //sn码
                    phone: '', //归属代理账号
                    pay_type: '', //交易方式
                    brand_id: '', //终端类型id
                    card_type: '', //卡类型
                    real_name: '', //归属代理名称
                    company: '', //d代理商公司名称
                    end_time: '', //交易结束日期
                    start_time: '', //交易开始日期
                    terminal_number: '', //终端编号
                    merchant_number: '', //商户编号
                    transaction_number: '', //订单号
                    type: 1, //默认团队交易
                    page: 1,
                    limit: 10,

                },
                transctionTable: [],
                page: {
                    currentPage: 1, //当前页码
                    pageSize: 10, //条数
                    total: 0  //总数
                },
                searchForm: {
                    page: 1,
                    limit: 10,
                    brand_id: '', //终端类型
                    terminal_sn: '', //sn
                    name: '', //归属人姓名
                    phone: '', //归属人账号
                    start_time: '',
                    end_time: '',
                    type: 1,
                },
                loading: true,
                downLoading: false, //导出loading
                level: sessionStorage.getItem('level')
            }
        },
        created() {
            this.pickerOptions.disabledDate = (time) => { //禁用日期
                if (this.currentDate !== '') {
                    let tempTime = 3600 * 1000 * 24 * 30;
                    let timer = new Date(this.currentDate).getTime();
                    let minTime = timer - tempTime;
                    let maxTime = timer + tempTime;
                    return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
                }
                return time.getTime() > Date.now();
            }
            this.pickerOptions.onPick = ({ minDate, maxDate }) => { //当前选中的日期
                this.currentDate = minDate.getTime();
                if (maxDate) {
                    this.currentDate = '';
                }
            }
        },
        mounted() {
            this.handleDefaultTime();
            this.$api.post('brand/brand_list', {}, res => { //获取终端类型
                if (res.code == 0) {
                    this.brandList = res.data.list;
                } else {
                    this.$message.success(res.msg);
                }
            });
            this.$api.post('type/pay_type', {}, res => { //获取支付类型
                if (res.code == 0) {
                    this.payTypeList = res.data;
                } else {
                    this.$message.success(res.msg);
                }
            });
            this.getData(this.transctionForm);//初始化
        },
        components: {
            paginations,
            transactionInfo,
            transactionStatus
        },
        methods: {
            typeChange(val) { //监听radio
                this.transctionForm.type = val;
                this.page.currentPage = 1; //重置分页
                this.transctionForm.page = 1; //重置
                // 表单提交
                this.getData(this.transctionForm);
            },
            handleSearch(transctionForm) {
                this.page.currentPage = 1; //重置分页
                this.transctionForm.page = 1; //重置
                // 表单提交
                this.getData(transctionForm);
            },
            handleInfo(row) { //查看
                this.infoIsShow = true;
                this.detail = row;
            },
            handleInfos(row) { //查看
                this.statusIsShow = true;
                this.detail = row;
            },
            infoClose() { //关闭弹窗
                this.infoIsShow = false;
                this.statusIsShow = false;
            },
            //分页
            getCurrent(page) {
                this.loading = true;
                // 获取当前页修改的值
                this.page.currentPage = page;
                this.transctionForm.page = this.page.currentPage;
                this.transctionForm.limit = this.page.pageSize;
                this.getData(this.transctionForm);
            },
            getPageSize(limit) {
                this.page.currentPage = 1; //重置分页
                // 获取条数发生改变的值
                this.loading = true;
                this.page.pageSize = limit;
                this.transctionForm.page = this.page.currentPage;
                this.transctionForm.limit = limit;
                this.getData(this.transctionForm);
            },
            getData(params) {
                this.$api.post("transaction/getList", params, res => {
                    if (res.code == 0) {
                        let data = res.data;
                        let { count, list, money_count } = data;
                        this.page.total = count; //总数
                        this.transctionTable = list;
                        this.tableTitle = { count, money_count };
                    } else {
                        this.$message.error(res.msg);
                    }
                    //渲染结束后取消加载
                    this.loading = false;
                })
            },
            formatSettle(row) {
                let settle = ''; //1.T+0 2.T+1
                switch (row.settle_type) {
                    case 1:
                        settle = 'T+0';
                        break;
                    default:
                        settle = 'T+1';
                        break;
                }
                return settle;
            },
            formatCard(row) {
                let card = ''; //1.借记卡 2.贷记卡
                switch (row.card_type) {
                    case 1:
                        card = '借记卡';
                        break;
                    default:
                        card = '贷记卡';
                        break;
                }
                return card;
            },
            handleDownLoad(searchForm) { //导出
                this.downLoading = true;
                this.$api.post("transaction/getListDown", searchForm, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        var link=this.$file_url+res.data;
                        window.open(link)
                    } else {
                        this.$message.error(res.msg);
                    }
                    //渲染结束后取消加载
                    this.downLoading = false;
                })
            },
            handleDefaultTime() { //默认获取三十天
                let date =this.$moment().endOf('day').format('x');
                this.transctionForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
                this.transctionForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD HH:mm:ss");
                this.rangeDate = [this.transctionForm.start_time, this.transctionForm.end_time];
            },
            pickerChange(DateArr) { //时间选择器
                this.transctionForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.transctionForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
                console.log(this.transctionForm.end_time)
                this.rangeDate = [this.transctionForm.start_time, this.transctionForm.end_time];
            },
        },
    };
</script>

<style lang="scss" scope>
    .MAM_terminalTransaction {
        .el-input__inner {
            font-size: 12px;
        }
        .el-form-item {
            margin-bottom: 5px;
        }
        .tableTitle {
            display: inline-block;
            margin-right: 20px;
        }
    }
</style>
